import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Invoice } from './invoice.model';
import { InvoiceService } from './invoice.service';
import {  PaymentService } from '../payment';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class InvoicePopupService {
    private isOpen = false;
    private defaultStatus: any = 'DRAFT';
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private invoiceService: InvoiceService,
        private paymentService: PaymentService
    ) { }

    open(component: Component, id?: number | any, paymentId?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.invoiceService.find(id).subscribe(invoice => {
                if (invoice.dateIssued) {
                    invoice.dateIssued = {
                        year: invoice.dateIssued.getFullYear(),
                        month: invoice.dateIssued.getMonth() + 1,
                        day: invoice.dateIssued.getDate()
                    };
                }

                if (invoice.dueDate) {
                    invoice.dueDate = {
                        year: invoice.dueDate.getFullYear(),
                        month: invoice.dueDate.getMonth() + 1,
                        day: invoice.dueDate.getDate()
                    };
                }
                this.invoiceModalRef(component, invoice);
            }, (error: HttpErrorResponse) => {
                this.isOpen = false;
            });
        } else {
            if (paymentId) {
                // We are creating a invoice for a specific payment
                this.paymentService.getVirtualInvoiceForPayment(paymentId).subscribe(virtualInvoice => {
                    if (virtualInvoice.dateIssued) {
                        virtualInvoice.dateIssued = {
                            year: virtualInvoice.dateIssued.getFullYear(),
                            month: virtualInvoice.dateIssued.getMonth() + 1,
                            day: virtualInvoice.dateIssued.getDate()
                        };
                    }

                    if (virtualInvoice.dueDate) {
                        virtualInvoice.dueDate = {
                            year: virtualInvoice.dueDate.getFullYear(),
                            month: virtualInvoice.dueDate.getMonth() + 1,
                            day: virtualInvoice.dueDate.getDate()
                        };
                    }
                    return this.invoiceModalRef(component, virtualInvoice);
                });
            } else {
                let newInvoice: Invoice = new Invoice();
                // initialize the invoice
                let today: Date = new Date();
                newInvoice.subTotal = 0;
                newInvoice.taxAmount = 0;
                newInvoice.taxRate = 0;
                newInvoice.total = 0;
                newInvoice.status = this.defaultStatus;
                setTimeout(() => {
                    // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                    return this.invoiceModalRef(component, newInvoice);
                });
            }
        }
    }

    invoiceModalRef(component: Component, invoice: Invoice): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.invoice = invoice;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice/invoice-popup.service.ts